/** 在路由路径改变时进行上报，需要放在 <Router>组件内 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackToLogger } from 'utils/logger';
import { TrackLogActionEnum } from 'constants/logger';

export default function PageViewReport() {
  const currentLocation = useLocation();

  useEffect(() => {
    trackToLogger({
      logAction: TrackLogActionEnum.PV,
      logContent: {
        path: currentLocation?.pathname,
        domain: window.location.hostname,
      },
    });
  }, [currentLocation]);

  return null;
}
